// fleet-generated: do not edit by hand
//
// Rendered from    : infra/fleet/artifacts/ui-core/switch.tmpl.tsx
// Parameters       : infra/fleet/registry/repos.ts  (entry "vigia-fleet-app")
// Destination      : packages/fleet/ui/src/switch.tsx
//
// TO CHANGE THIS FILE, edit the template or the registry entry in infra and
// re-render. Editing it here is reverted by the next render, and the guard
// in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo vigia-fleet-app
//     node fleet/fleet.ts check --repo vigia-fleet-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { splitProps } from "solid-js";
import { cn } from "@vigia/shared";

interface SwitchProps {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  class?: string;
}

export function Switch(props: SwitchProps) {
  const [local, others] = splitProps(props, ["checked", "onCheckedChange", "disabled", "class"]);

  return (
    <button
      type="button"
      role="switch"
      aria-checked={local.checked}
      disabled={local.disabled}
      onClick={() => local.onCheckedChange?.(!local.checked)}
      class={cn(
        "inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        local.checked ? "bg-primary" : "bg-muted",
        local.class,
      )}
      {...others}
    >
      <span
        class={cn(
          "pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform",
          local.checked ? "translate-x-4" : "translate-x-0",
        )}
      />
    </button>
  );
}
